import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IAddress } from '../../../../../models/address.model';
import { BaryAddressService } from '../../../../../services/bary-address.service';
import { ActivatedRoute } from '@angular/router';
import { BarySiretComponent } from '../../../components';
import { TranslateDirective } from '../../../../../directives/translate.directive';

@Component({
  selector: 'jhi-siret-form',
  imports: [BarySiretComponent, TranslateDirective],
  standalone: true,
  templateUrl: './siret-form.component.html',
})
export class SiretFormComponent {
  readonly #baryAddressUtil = inject(BaryAddressService);

  @Input() baryForm!: FormGroup;

  get siretControl(): FormControl {
    return this.baryForm.get('companyForm')?.get('siret') as FormControl;
  }

  get vatNumberControl(): FormControl {
    return this.baryForm.get('companyForm')?.get('vatNumber') as FormControl;
  }

  get companyNameControl(): FormControl {
    return this.baryForm.get('companyForm')?.get('companyName') as FormControl;
  }

  updateAddress($event: IAddress): void {
    this.baryForm.get('addressForm')?.patchValue($event);
    this.baryForm.get('addressForm')?.get('autofill')?.setValue(this.#baryAddressUtil.updateGmapsAddressString($event));
  }
}
